import { useState } from "react";
import uploadimg from "../../src/Images/uploadimg.png";
import HttpClient from "../../src/utils/HttpClient";
import Delete from "../../src/Images/Delete.png";
import validateBannerImage from '../utils/validateBannerImage';

const MemberBannerProfileUpdate = ({ closemodal, url, setUrl, updateForm, setIsUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [hasData, setHasData] = useState(false);
  const [error, setError] = useState("");

  const imageUpload = async (file) => {
    if (!file) return;
    setError("");
    setLoading(true);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await HttpClient.fileUploadWithoutAuth("image-upload", "POST", formData);
      if (res.status) {
        setUrl(res.data.url);
        setHasData(true);
      } else {
        setError(res?.message || "Error while uploading image");
        console.error("Error while uploading image");
      }
    } catch (error) {
      setError("Error while uploading image");
      console.error("Upload failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (event) => {
    setError("");
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        setError("Error: Please upload a valid image file (PNG/JPEG)");
        return;
      }else if(!await validateBannerImage(file)){
        setError("Banner image must be between 982 and 283 height.");
        return;
      }

      // Validate file size (5MB = 5242880 bytes)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        setError("Error: File size must be less than or equal to 5MB");
        return;
      }
      setFile(file);
      imageUpload(file);
    }
  };

  const handleSave = () => {
    if (url) {
      updateForm("banner", url);
      setUrl("");
      setFile(null);
      setHasData(false);
      setIsUpdate(true)
      closemodal();
    }
  };

  const removeBannerImage = async (e) => {
    e.preventDefault();
    updateForm("banner", "");
    setUrl("");
    setFile(null);
    setHasData(false);
    setIsUpdate(true)
  };

  return (
    <div className="uploabannermodalbgshadow">
      <div className="uploabannermodalbg">
        <h5 className="mt-2 p-0 m-3">Update Banner</h5>
        <div className="remove-icon-image-new dettetstyyiocnnhui">
          <img src={Delete} alt="Delete icon" onClick={(e) => removeBannerImage(e)} />
        </div>
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <hr />

        <div className="upldbantrtupldbannerdiv">

          <p className="selletxtcbabbtxttpp">
            Select and upload the files of your choice
          </p>
          <p className="error pl-4">{error != '' && error}</p>
        </div>

        <div className="uploadaboxdeshhbdivbrdrmain"
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: "cover"
          }}
        >

          <div className="uploadaboxdeshhbdiv">
            <div className="filedibbhsjj">
              <input
                type="file"
                className="filedibbhsjjdiflediv"
                onChange={handleFileChange}
                accept="image/*"
                style={{ display: "none" }}
              />
              <div className="uploadimgdibbavimg">
                <img src={uploadimg} alt="Placeholder for upload" />
              </div>
              <h4 className="choosttflttxtpp">
                Choose a file to upload it here
              </h4>
              <p style={{ textAlign: "center" }}>(Pixel Size : 982 x 283 PNG/JPEG )</p>
              <p className="jjshpsttsrrtxtpp">
                JPEG, PNG formats, up to 5 MB
              </p>
              <button
                className="bttserfilelytxyp"
                style={{
                  margin: "auto",
                  background: "#fff"
                }}
                onClick={() =>
                  document.querySelector(".filedibbhsjjdiflediv").click()
                }
              >
                Browse File
              </button>
            </div>
          </div>

          {hasData && (
            <div className="svavtatvvbtnnmdivmaokin">
              <button className="svavtatvvbtnnm" onClick={handleSave}>
                Save
              </button>
            </div>
          )}
        </div>

        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MemberBannerProfileUpdate;
